<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.proje_akislari"  url="CreateProjectFlow" :show_button="true" icon="plus" buttontype="primary" :label="$store.state.languages.lang_phrases.yeni_ekle"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<template v-if="flows.length==0">
<div class="flex align-items-center justify-content-center mb-8 mt-8">
<h3 class="text-primary font-medium">Henüz hiç kayıt oluşturulmamış</h3>

</div>
</template>
<template v-else>


<!--<ContentTable :data="flows" :columns="columns" routename="Flow" deleteobjectname="flow" @dataDeleted="getData"></ContentTable>-->



<ContentTable :data="flows" :columns="columns" routename="Flow"  deleteobjectname="flow" @dataDeleted="getData"  :sortable="true" @rowsReorders="listupdated"></ContentTable>


</template>

</template>



</div>
</template>

<script>
export default {

  name: 'BrandProjects',

  data () {
    return {
    	flows:[],
    	loading:true,
       columns:[
      {
        type:"text",
        field:"name",
        header:"isim",
        hide_on_mobile:false,
        with_route:true
      },
      {
        type:"pill",
        field:"type",
        header:"tur",
        options:[
          {
            name:"self_evaluation",
            color:"#ff6600",
            text:"self_evaluation",
          },
          {
            name:"education",
            color:"#3b82f6",
            text:"egitim",
          },
         {
            name:"verification",
            color:"#7e2f8d",
            text:"verification",
          },
          {
            name:"audit",
            color:"#352f8d",
            text:"audit",
          },
        ],
      }, 

      {
        type:"date",
        field:"start_date",
        header:"baslangic_tarihi",
        hide_on_mobile:true,
      },
      {
        type:"date",
        field:"end_date",
        header:"bitis_tarihi",
        hide_on_mobile:true,
      },     
      
      ]
    }
  },
   mounted()
  {
  	this.getData()
  },
  methods:{
  	async getData()
    {

        this.loading = await true
        this.flows = await this.generalApiGetWithoutLoader("project_flows/"+this.$route.params.id)
        console.log(this.flows)
        this.loading = await false
    },
    listupdated(data)  
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append('list', JSON.stringify(data));
      this.generalSubmission(formdata,"flow/reorder/"+this.$route.params.id,this.afterlistupdated)
    },
    afterlistupdated(response)
    {
      console.log(response.data)
      this.flows = response.data
    },
      
  }
}
</script>

<style lang="css" scoped>
</style>